import React, { FunctionComponent } from 'react';
import IPlatformConfig from '../../../../common/model/IPlatformConfig';
import IWidgetConfiguration from '../../../../../../common/model/IWidgetConfiguration';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import useWidgetContext from '../../../../common/react/useWidgetContext';
import ActionButtons from '../../presentational/actionButtons/ActionButtons';
import EnquireNowContainer from './enquire/EnquireNowContainer';
import SaveButtonContainer from './save/SaveButtonContainer';
import SubmitContainer from './submit/SubmitContainer';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';
import { IStock } from '../../../../../../common/model/ICarConfiguration';
import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../store/selectors/carConfigurationSelectors';

export type ActionButtonsDisplayConfig = IWidgetConfiguration &
  IPlatformConfig & {
    externalSaveOffer: boolean;
    disabled?: boolean;
  };

interface IActionsButtonsContainerProps {
  disabled?: boolean;
}

const ActionButtonsContainer: FunctionComponent<IActionsButtonsContainerProps> = ({ disabled }) => {
  const { configuration } = useWidgetContext();
  const { platformConfig } = usePlatformConfig();
  const {
    spc: {
      productConfigurator: { externalSaveOffer },
      customise: { displayReserveOnline },
    },
  } = useTheme<ISpcTheme>();
  const config: ActionButtonsDisplayConfig = {
    ...configuration,
    ...platformConfig,
    ...{ externalSaveOffer },
    disabled,
  };

  // TODO: Temporary solution to unblock testing.
  const stock: IStock = useSelector(carConfigurationSelectors.getConfigurationStock);
  const showSubmitButton = !(config.hideSubmitWhenNoStock && stock?.count <= 0) && displayReserveOnline;

  return (
    <ActionButtons>
      {showSubmitButton && <SubmitContainer config={config} />}
      <EnquireNowContainer config={config} />
      <SaveButtonContainer config={config} />
    </ActionButtons>
  );
};

export default ActionButtonsContainer;
